import React, { useState, useEffect } from 'react';
import '../../styles/User/faq.css'
import TopBar from '../../components/User/TopBar';
import { questions } from '../../data/questions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import ReactGA from 'react-ga';

function Faq() {

  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleAnswer = (questionId) => {
    setActiveQuestion(questionId === activeQuestion ? null : questionId)
  }
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, [])
  
  return (
    <div className='faq'>
        <TopBar />
        <div className="questions-title">
            <h1>Frequently Asked Questions</h1>
            <div className="questions">
              {questions.map((question,index ) => {
                return (
                  <div key={index} className='question' onClick={() => toggleAnswer(question.id)}>
                    <div className="top">
                      <h3>{question.question}</h3>
                      <FontAwesomeIcon icon={activeQuestion === question.id ? faMinusCircle :faPlusCircle} className='question-icon' />
                    </div>
                    <div className={activeQuestion === question.id ? "answer show" : "answer"}>
                      {question.answer}
                    </div>
                  </div>
                )
              })}
            </div>
        </div>
    </div>
  )
}

export default Faq